import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-extrabold text-foreground-900">精选专题</h2>
          <p className="text-sm text-foreground-600 mt-2">精心策划的影视专题合集，发现更多你感兴趣的好内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.map((item) => (
            <article key={item.id} className="group cursor-pointer">
              <div className="relative rounded-xl overflow-hidden aspect-[16/9] mb-3 md:mb-4 bg-background-100">
                <img
                  src={item.image}
                  alt={`91视频 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors mb-1.5">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{item.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}